import {AfterViewInit, Component, Directive, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation} from '@angular/core';
import {BsModalRef, BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import {UploadFileComponent} from '../../../ui/upload/uploadfile.component';
import {environment} from '../../../../../environments/environment';
import {ToastrService} from 'ngx-toastr';
import {ConfirmDialogComponent} from '../../../dialog/confirmdialog.component';
import {language} from '../../../../language/vn';
import {CommandUtil} from '../../../../global/commandutil';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import {Subject} from 'rxjs';
import {DatePipe} from '@angular/common';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {VanBanDen} from '../../../../models/vanbanden/vanbanden';
import {VanBanDenFile} from '../../../../models/vanbanden/vanbandenfile';
import {VanBanDenXL} from '../../../../models/vanbanden/vanbandenxl';
import {VanBanDenService} from '../../../../service/vanbanden/service-vanbanden';;
import {VanBanDenXLService} from '../../../../service/vanbanden/service-vanbandenxl';

import {VanBanDenComment} from '../../../../models/vanbanden/vanbandencomment';
import {NavItemService} from '../../../../service/staff/service-navitem';
import {VanBanDenFileXLService} from '../../../../service/vanbanden/service-vanbandenfilexl';
import {DomSanitizer} from '@angular/platform-browser';
import {CkEditorUploadAdapter} from '../../../../global/upload-ckeditor';
@Component({
  templateUrl: './xuly.component.html',

})
export class XuLyTongHopVanBanDenComponent implements OnInit, AfterViewInit {
  @ViewChild(UploadFileComponent)
  public uploadFileComponent: UploadFileComponent;
  public id: number = -1;
  public language = language;
  public showAction = true;
  public frmGroup: FormGroup;
  public  onClose: Subject<boolean>;
  public vanBanDenItem: VanBanDen = new VanBanDen();
  public vanBanDenFiles: VanBanDenFile[] = [];
  public vanBanDenXuLyList: VanBanDenXL[] = [];
  public vanBanDenCommentList: VanBanDenComment[] = [];
  public editor = ClassicEditor;
  public submitValidate = false;
  public uploadUrl: String;
  public deleteUrl: String;
  public fileLists: Object[]=[];
  public permissionGXL: boolean = false;
  public status: number = environment.dangxuly;
  public statusHoanThanh: number = environment.hoanthanh;
  constructor(
    public vanBanDenService: VanBanDenService,
    public toastr: ToastrService,
    public formBuilder: FormBuilder,
    public bsModalService: BsModalService,
    public datepipe: DatePipe,
    public _bsModalRef: BsModalRef,
    public commandUtil: CommandUtil,
    public vanBanDenFileXLService: VanBanDenFileXLService,
    public vanBanDenXuLyService: VanBanDenXLService,
    public navItemService: NavItemService,
    public sanitizer: DomSanitizer
  ) {
  }
  ngAfterViewInit() {

  }
  public onReady( editor ) {
    editor.ui.getEditableElement().parentElement.insertBefore(
      editor.ui.view.toolbar.element,
      editor.ui.getEditableElement()
    );
    editor.editing.view.change( writer => {
      writer.setStyle( 'height', '300px', editor.editing.view.document.getRoot() );
      writer.setStyle( 'border', '1px solid', editor.editing.view.document.getRoot() );
    } );
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
      return new CkEditorUploadAdapter(loader);
    };
  }
  public updateView()
  {
    this.vanBanDenXuLyService.changeView(this.id, Sessioncommand.staffId).subscribe(
      {    next: (data) => {
          console.log(data);
        },
        error: error => {
          this.toastr.error(language.error, language.message);
        }
      });
  }

  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();

  }
  public changeStatus()
  {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.confirm_hoanthanh_question,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.vanBanDenXuLyService.changeStatus(this.id, environment.hoanthanh, Sessioncommand.staffId).subscribe(
          {
            next: (data) => {
              this.toastr.success(language.change_hoanthanh_success, language.message);
              Sessioncommand.vanBanDenStatus = 0;
              Sessioncommand.notification = true;
              this.onSave();

            },
            error: error => {
              this.toastr.error(language.error, language.message);
            }
          }
        );
      }
    });
  }
  ngOnInit(): void {
    this.onClose = new Subject();
    this.uploadUrl= this.vanBanDenFileXLService.urlUpload;
    this.deleteUrl= this.vanBanDenFileXLService.urlDelete;
    this.frmGroup = new FormGroup({
      id: new FormControl(this.id),
      traLoi: new FormControl(),
      trangThai: new FormControl(),
      staffId: new FormControl()

    });
    this.frmGroup = this.formBuilder.group({
      id: ['', Validators.nullValidator],
      traLoi: ['', Validators.nullValidator],
      trangThai: ['', Validators.nullValidator],
      staffId: ['', Validators.nullValidator]
    });
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId, '0032', true).subscribe(
      x => {
        this.permissionGXL = x >0? true: false;
      }
    );
  }
  public edit(id: number, show: boolean) {
    this.id = id;
    this.showAction = show;
    this.updateView();
    this.vanBanDenService.getById(id).subscribe(data=> this.vanBanDenItem = data);

  }
  public actionYKien ()
  {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      this.status === environment.hoanthanh ? language.confirm_hoanthanh_question :  language.confirm_save_xuly_question,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.frmGroup.value.id = this.id;
        this.frmGroup.value.trangThai = this.status;
        this.frmGroup.value.staffId = Sessioncommand.staffId;
        this.vanBanDenXuLyService.updateXuLy(this.frmGroup.value).subscribe(
          {    next: (data) => {
              if(data !== -1) {
                this.uploadFileComponent.id = data;
                this.uploadFileComponent.uploadCommand.upload(this.uploadFileComponent.uploadCommand.getFilesData());
                this.toastr.success(this.status === environment.hoanthanh? language.change_hoanthanh_success: language.message_xuly_success, language.message);
                Sessioncommand.vanBanDenStatus = 0;
                Sessioncommand.notification = true;
              }else
                this.toastr.warning(language.error_message_success, language.message);
              this.onSave();
            },
            error: error => {
              this.toastr.error(language.error, language.message);
            }
          });
      }
    });

  }

  public onSubmit()
  {
    this.submitValidate = true;
    if(this.frmGroup.invalid)
      return;
    this.actionYKien();
  }
  public onSave(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }
}

